import * as React from 'react';

import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';

import { LogoLoaderPage } from '@commonTuna/react/components/UI/LogoLoader/LogoLoader';
import { Region } from '@commonTuna/react/objects/Region';

import '@app/scss/pages/home.scss';

const RegionInner: React.FC<{region: Region}> = ({ region }) => {
	return (<div className="container view-page">
		<div className="site-headline site-headline_with-button clearfix">
			<h1 className="pull-left">{region?.name}</h1>
		</div>
		<div>
			{region?.description ? <div dangerouslySetInnerHTML={{ __html: `${region?.description}` }} /> : '-'}
		</div>
	</div>);
};

const RegionPage: React.FC = () => {
	return (
		<ServerPageProvider
			path="location"
			defaultTitle="Location"
			loader={<LogoLoaderPage />}
			inner={(page) => (
				<RegionInner
					region={page?.item}
				/>
			)}
		/>
	);
};

export default RegionPage;
